export default __webpack_public_path__ + "advantage-33762c8.png";